export default __webpack_public_path__ + "static/media/Button_Tooltip.f1ea3bd0.svg";